import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import { Input } from "../../../../../../shadcn/components/ui/input";
import React, { useEffect, useState, useRef } from "react";
import { Calendar } from "../../../../../../shadcn/components/ui/calendar";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../../../../shadcn/components/ui/popover";
import CalendarIcon from "../../../../../../icons/CalendarIcon";
import { Button } from "../../../../../../shadcn/components/ui/button";

export const DateTimePickerTypeRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const ctx = useJsonForms();
  const [date, setDate] = useState<Date | undefined>(new Date());
  const [value, setValue] = React.useState<any>(data === undefined ? "" : data);
  const [customError, setCustomError] = useState("");
  const positionRef = useRef<HTMLInputElement>(null);

  const show = uischema?.options?.show;
  useEffect(() => {
    if (show == false) {
      handleChange(path, {});
      setValue({});
    }
  }, [show]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
        return;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  const generateTimes = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 5) {
        const formattedHour = String(hour).padStart(2, "0");
        const formattedMinute = String(minute).padStart(2, "0");
        times.push(`${formattedHour}:${formattedMinute}`);
      }
    }
    return times;
  };

  const times = generateTimes();

  const handleDateSelect = (item: any) => {
    let d = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(item);

    let newObj = {
      date: d,
      time: data?.time,
    };

    handleChange(path, newObj);
    setDate(item);
    setValue(newObj);
  };

  const handleTimeSelect = (item: any) => {
    let newObj = {
      date: data?.date,
      time: item,
    };

    handleChange(path, newObj);
    setValue(newObj);
  };

  return show === false ? (
    <></>
  ) : (
    <div ref={positionRef} className="w-full">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={
              "w-full h-[50px] rounded-none font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey"
            }
          >
            <div className="flex justify-between w-full items-center">
              <div className="relative w-full">
                <Input
                  id="name"
                  value={
                    (value?.date ? value?.date : "") +
                    " " +
                    (value?.time ? value?.time : "")
                  }
                  onChange={() => {}}
                  required
                  className="bg-transparent border-none hover:cursor-pointer pointer-events-none py-4  peer  autofill:bg-white focus:border-brand-orange pb-[6px] h-[50px]  outline-none  border  w-full   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey"
                />
                <label
                  htmlFor="name"
                  className={`absolute h-full font-openSans font-normal text-web-body-sm text-wrap mid:text-web-body-lg leading-3 mid:leading-5 ${
                    !value?.date && !value?.time
                      ? "text-brand-borderGrey"
                      : "text-transparent"
                  }   left-0    pointer-events-none  transition-all duration-300 peer-valid:h-fit  peer-placeholder-shown:top-1.5 peer-placeholder-shown:text-gray-400 peer-placeholder-shown:text-[10px] peer-focus:top-1.5 peer-focus:text-[10px]  peer-focus:leading-[13px] peer-focus:h-fit  peer-focus:text-brand-orange peer-valid:top-1 peer-valid:text-[10px] peer-valid:leading-[13px] peer-valid:text-brand-borderGrey`}
                >
                  <p className="py-auto  flex flex-col justify-center h-full ">
                    {schema?.title}
                  </p>
                </label>
              </div>
              <CalendarIcon className="ml-auto h-6 w-6 " />
            </div>
          </Button>
        </PopoverTrigger>
        <PopoverContent className=" w-auto p-0" align="start">
          <div className="mobile:flex">
            <Calendar
              mode="single"
              classNames={{
                nav_button_previous: "absolute left-1 border-none",
                nav_button_next: "absolute right-1 border-none",
              }}
              selected={date}
              onSelect={(e) => handleDateSelect(e)}
              disabled={(date) => date < new Date()}
              initialFocus
            />
            <div className="px-6 py-1 mobile:py-3 border rounded-lg pl-16 mobile:pl-6  flex mobile:flex-col items-center">
              <p className="mb-2 mobile:mb-0">Time</p>
              <ul className="space-y-1 mobile:mt-3 ml-5 mobile:ml-0 overflow-y-auto  h-[90px]  mobile:h-[230px]">
                {times.map((time, index) => (
                  <li
                    key={index}
                    onClick={() => handleTimeSelect(time)}
                    className={`p-0.5 hover:cursor-pointer w-[100px] mobile:w-auto font-openSans font-normal text-web-body-md leading-5 hover:bg-brand-bgBlack hover:text-white text-center ${
                      data?.time === time
                        ? "bg-brand-bgBlack text-white"
                        : "bg-white"
                    }  rounded `}
                  >
                    {time}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </PopoverContent>
      </Popover>
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-2"}
        >
          {customError}
        </label>
      )}
    </div>
  );
};

export default withJsonFormsControlProps(DateTimePickerTypeRenderer);
